import {querySelectorAll} from '../utilities';

const minusSignRegex = /\u2212/g;
const halfWidthProlongedSoundMarkRegex = /\uff70/g;

const fullWideMinusHyphen = '\uff0d';
const halfWideMinusHyphen = '\u002d';

const replacer = (value: string) => {
  return value
      .replace(minusSignRegex, fullWideMinusHyphen)
      .replace(halfWidthProlongedSoundMarkRegex, halfWideMinusHyphen);
};

document.addEventListener('DOMContentLoaded', () => {
  const inputs = querySelectorAll('input.optimize-input');
  inputs.forEach((input: HTMLInputElement) => {
    input.addEventListener('blur', e => {
      const target = e.target as HTMLInputElement;
      if (target && target.value) {
        target.value = replacer(target.value);
      }
    });
  });

  const forms = querySelectorAll('form');
  forms.forEach((form: HTMLFormElement) => {
    form.addEventListener('submit', e => {
      const container = e.target as HTMLFormElement;
      const inputs = querySelectorAll('input.optimize-input', container);
      inputs.forEach((input: HTMLInputElement) => {
        if (input && input.value) {
          input.value = replacer(input.value);
        }
      });
    });
  });
});
